module.exports = __webpack_public_path__ + "img/omimg3.376c8a5a.png";